var map = {
	"./EURO/bank_note_10.png": 70650,
	"./EURO/bank_note_100.png": 34231,
	"./EURO/bank_note_20.png": 24657,
	"./EURO/bank_note_200.png": 42279,
	"./EURO/bank_note_5.png": 12387,
	"./EURO/bank_note_50.png": 74309,
	"./EURO/bank_note_500.png": 89205,
	"./EURO/coin_1.png": 51370,
	"./EURO/coin_10.png": 18934,
	"./EURO/coin_100.png": 37639,
	"./EURO/coin_2.png": 49634,
	"./EURO/coin_20.png": 62738,
	"./EURO/coin_200.png": 7202,
	"./EURO/coin_5.png": 990,
	"./EURO/coin_50.png": 8997,
	"./PLN/bank_note_10.png": 27713,
	"./PLN/bank_note_100.png": 95523,
	"./PLN/bank_note_20.png": 64198,
	"./PLN/bank_note_200.png": 17951,
	"./PLN/bank_note_50.png": 61203,
	"./PLN/bank_note_500.png": 41523,
	"./PLN/coin_1.png": 2714,
	"./PLN/coin_10.png": 51216,
	"./PLN/coin_100.png": 28177,
	"./PLN/coin_2.png": 88519,
	"./PLN/coin_20.png": 59416,
	"./PLN/coin_200.png": 55298,
	"./PLN/coin_5.png": 68525,
	"./PLN/coin_50.png": 84927,
	"./PLN/coin_500.png": 7719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16514;